import { IUserReport } from "../services/types/users.types";
import { TSpecialization } from "../types/types";
import { tWithKeyAttr as t } from "../i18nHelper";


function flattenObject(
  obj: object,
  parentKey = "",
  separator = "."
): Record<string, unknown> {
  const flattened: Record<string, unknown> = {};

  for (const [key, value] of Object.entries(obj)) {
    const newKey = parentKey ? `${parentKey}${separator}${key}` : key;

    if (typeof value === "object" && value !== null && !Array.isArray(value)) {
      // Recursively flatten nested objects
      Object.assign(flattened, flattenObject(value, newKey, separator));
    } else {
      // Assign non-object values directly
      flattened[newKey] = value;
    }
  }

  return flattened;
}

export function filterObjectsByString<T extends object>(
  inputString: string,
  arrayOfObjects: T[]
): T[] {
  return arrayOfObjects.filter((obj) => hasMatches(obj, inputString));
}

function hasMatches(object: object, searchString: string): boolean {
  const searchWords = searchString.toLowerCase().split(" "); // Split the search string into words and convert to lowercase
  // Check if every word in the search string is found in the object values
  return searchWords.every((word) =>
    Object.values(flattenObject(object)).some((value) => {
      if (typeof value === "string") {
        return value.toLowerCase().includes(word); // Check for string matches
      } else if (typeof value === "number") {
        return value.toString().includes(word); // Convert number to string for matching
      }
      return false; // Ignore other types
    })
  );
}

export function filterUsersByTreatmentProgram<T extends IUserReport>(
  programId: number,
  arrayOfObjects: T[]
): T[] {
  if (programId === 0) {
    return arrayOfObjects.filter(
      (u) => u.AppointmentsProgramsNum === programId
    );
  } else if (programId === 1) {
    return arrayOfObjects.filter((u) => u.AppointmentsProgramsNum !== 0);
  } else return arrayOfObjects;
}
export function filterUsersByTreatmentProgramStatus<T extends IUserReport>(
  programStatusId: number,
  arrayOfObjects: T[]
): T[] {
  if (programStatusId > -1) {
    return arrayOfObjects.filter(
      (u) => u?.AppointmentsProgramStatus === programStatusId
    );
  } else return arrayOfObjects;
}
export function filterUsersByString<T extends IUserReport>(
  inputString: string,
  arrayOfObjects: T[]
): T[] {
  return arrayOfObjects.filter((obj) => {
    const { Id, FullName, FirstName, LastName, Passport, Phone, Email } = obj.Users;
    const searchString = inputString.toLowerCase();

    return (
      Id?.toString().includes(searchString) ||
      FirstName?.toLowerCase().includes(searchString) ||
      LastName?.toLowerCase().includes(searchString) ||
      FullName?.toLowerCase().includes(searchString) ||
      Passport?.includes(searchString) ||
      Phone?.includes(searchString) ||
      Email?.includes(searchString)
    );
  });
}

export function filterSpecializationsBySpecializationType<T extends TSpecialization>(
  specializationType: number,
  arrayOfObjects: T[]
): T[] {
  return arrayOfObjects.filter((obj) => {
    const { therapistsSpecializationsTypesId } = obj;
    if(specializationType === 0) return true
    return (
      therapistsSpecializationsTypesId === specializationType
    );

  });
}
